import React from "react"
import { useLanguage } from "../context/LanguageContext"
import { countryName, localeForLanguage } from "../data/countries"
import CountryFlag from "./CountryFlag"

export default function CountryPlace({ code, className = "" }) {
  const { language } = useLanguage()
  const name = countryName(code, localeForLanguage(language))
  if (!name) return null

  return (
    <span className={`country-place ${className}`.trim()}>
      <CountryFlag code={code} />
      <span>{name}</span>
    </span>
  )
}
